function createNamespace(name, implementation) {
  const res = otto[name];
  return [otto[name], res.set(implementation)];
}
function createEventTopic(...listeners) {
  return { [Symbol.onexus.event]: listeners };
}
function createFunction(handler) {
  return handler;
}
function createGenericFunction(handler) {
  return handler;
}

export { createEventTopic, createFunction, createGenericFunction, createNamespace };
/*                              */
